// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// USE THIS FILE ONLY FOR VARS THAT DEPEND ON PROD/DEV OR MANAGER/BROWSER APPLICATION
// For other variables, prefer using config configurations/environment-variables.json

export class environment {
  public static production: Boolean = false;
  public static applicationRoute = 'inspectionbrowser';
  public static isManager = false;
}
